import "../styles/carousel.css"
import Carousel from 'react-bootstrap/Carousel';

export const HomeCarousel = () => <div class="carousel-container">

  <Carousel fade>
    <Carousel.Item id="slide1">
      <img className="d-block" src={require("../img/3-2.png")} alt="First slide" />
    </Carousel.Item>
    <Carousel.Item id="slide2">
      <img className="d-block" src={require("../img/mean4.png")} alt="Second slide"/>
    </Carousel.Item>
    <Carousel.Item id="slide3">
      <img className="d-block" src={require("../img/alien3.png")} alt="Third slide"/>
    </Carousel.Item>
  </Carousel>

</div>
